<template>
  <v-card>
    <v-card-text>
      <form data-vv-scope="mgmtForm">
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.clean }}</v-subheader>
              <div class="queryValue" v-for="item in filterCleanList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-autocomplete
                :items="satisficationList"
                v-model="mgmtForm.clean"
                :label="labels.clean"
                item-text="label"
                item-value="value"
                data-vv-name="mgmtForm.clean"
                :data-vv-as="labels.clean"
                :error-messages="errors.collect('mgmtForm.clean')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.layout }}</v-subheader>
              <div class="queryValue" v-for="item in filterLayoutList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-autocomplete
                :items="satisficationList"
                v-model="mgmtForm.layout"
                :label="labels.layout"
                item-text="label"
                item-value="value"
                data-vv-name="mgmtForm.layout"
                :data-vv-as="labels.layout"
                :error-messages="errors.collect('mgmtForm.layout')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.vent }}</v-subheader>
              <div class="queryValue" v-for="item in filterVentList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-autocomplete
                :items="ventList"
                v-model="mgmtForm.vent"
                :label="labels.vent"
                item-text="label"
                item-value="value"
                data-vv-name="mgmtForm.vent"
                :data-vv-as="labels.vent"
                :error-messages="errors.collect('mgmtForm.vent')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md4 lg4>
              <v-checkbox
                color="primary"
                :label="labels.smokeReg"
                v-model="mgmtForm.smokeReg"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex md4 lg4></v-flex>
            <v-flex md4 lg4></v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.wasteDisp }}</v-subheader>
              <div class="queryValue" v-for="item in filterWasterDispList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-autocomplete
                :items="wasteDispList"
                v-model="mgmtForm.wasteDisp"
                :label="labels.wasteDisp"
                item-text="label"
                item-value="value"
                data-vv-name="mgmtForm.wasteDisp"
                :data-vv-as="labels.wasteDisp"
                :error-messages="errors.collect('mgmtForm.wasteDisp')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.wasteDispFreq }}</v-subheader>
              <div class="queryValue" v-for="item in filterWasteDispFreqList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-autocomplete
                :items="wasteDispFreqList"
                v-model="mgmtForm.wasteDispFreq"
                :label="labels.wasteDispFreq"
                item-text="label"
                item-value="value"
                data-vv-name="mgmtForm.wasteDispFreq"
                :data-vv-as="labels.wasteDispFreq"
                :error-messages="errors.collect('mgmtForm.wasteDispFreq')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.mgmtRemarks }}</v-subheader>
              <div class="queryValue">{{ mgmtForm.mgmtRemarks }}</div>
            </v-flex>
            <v-flex xs12 v-else>
              <v-textarea
                v-model="mgmtForm.mgmtRemarks"
                :label="labels.mgmtRemarks"
                :error-messages="errors.collect('mgmtForm.mgmtRemarks')"
                v-validate="'max:1000|entry'"
                data-vv-name="mgmtForm.mgmtRemarks"
                :data-vv-as="labels.mgmtRemarks"
                :counter="1000"
                :rows="8"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { satisficationList, ventList, wasteDispList, wasteDispFreqList } from './index'

export default {
  data() {
    return {
      labels: {
        clean: 'Cleanliness / Tidiness',
        layout: 'Layout / Congestion',
        vent: 'Ventilation',
        smokeReg: 'Smoking Regulation Enforced?',
        wasteDisp: 'Waste Disposal Method',
        wasteDispFreq: 'Disposal Frequency',
        mgmtRemarks: 'Management Comments'
      },
      mgmtForm: {
        survNo: undefined,
        verCnt: undefined,
        clean: undefined,
        layout: undefined,
        vent: undefined,
        smokeReg: false,
        wasteDisp: undefined,
        wasteDispFreq: undefined,
        mgmtRemarks: undefined,
        survDetType: 'management'
      },
      actionLabel: {
        exit: 'Exit',
        save: 'Save',
        reset: 'Reset'
      },
      loading: false,
      showErrorDialog: false,
      submitting: false,
      satisficationList: [],
      ventList: [],
      wasteDispList: [],
      wasteDispFreqList: []
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    riskSurveyMenu() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveySettings.menu
    },
    riskSurveyMaster() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMaster
    },
    riskSurveyDetails() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyDetails
    },
    riskSurveyMode() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMode
    },
    filterCleanList() {
      return this.satisficationList.filter((list) => {
        return list.value === parseInt(this.mgmtForm.clean)
      })
    },
    filterLayoutList() {
      return this.satisficationList.filter((list) => {
        return list.value === parseInt(this.mgmtForm.layout)
      })
    },
    filterVentList() {
      return this.ventList.filter((list) => {
        return list.value === parseInt(this.mgmtForm.vent)
      })
    },
    filterWasterDispList() {
      return this.wasteDispList.filter((list) => {
        return list.value === parseInt(this.mgmtForm.wasteDisp)
      })
    },
    filterWasteDispFreqList() {
      return this.wasteDispFreqList.filter((list) => {
        return list.value === parseInt(this.mgmtForm.wasteDispFreq)
      })
    }
  },
  methods: {
    async doInit() {
      this.mgmtForm.survNo = this.riskSurveyMaster.survNo
      this.mgmtForm.verCnt = this.riskSurveyMaster.verCnt
      this.loadInit()
    },
    loadInit() {
      this.mgmtForm.clean = parseInt(this.riskSurveyDetails.clean)
      this.mgmtForm.layout = parseInt(this.riskSurveyDetails.layout)
      this.mgmtForm.vent = parseInt(this.riskSurveyDetails.vent)
      this.mgmtForm.smokeReg = this.riskSurveyDetails.smokeReg
      this.mgmtForm.wasteDisp = parseInt(this.riskSurveyDetails.wasteDisp)
      this.mgmtForm.wasteDispFreq = parseInt(this.riskSurveyDetails.wasteDispFreq)
      this.mgmtForm.mgmtRemarks = this.riskSurveyDetails.mgmtRemarks
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    doExit() {
      this.$router.push({ name: 'riskSurveyListing' })
    },
    doReset() {
      this.mgmtForm.clean = undefined
      this.mgmtForm.layout = undefined
      this.mgmtForm.vent = undefined
      this.mgmtForm.smokeReg = false
      this.mgmtForm.wasteDisp = undefined
      this.mgmtForm.wasteDispFreq = undefined
      this.mgmtForm.mgmtRemarks = undefined
    }
  },
  created() {
    this.satisficationList = satisficationList
    this.ventList = ventList
    this.wasteDispList = wasteDispList
    this.wasteDispFreqList = wasteDispFreqList
  },
  mounted() {
    this.doInit()
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.$store.dispatch('riskSurveyInit').then(() => {
          this.doInit()
        })
      })
    } else {
      this.$store.dispatch('riskSurveyInit').then(() => {
        this.doInit()
      })
    }
  },
  mixins: [MessageMixin],
  components: {}
}
</script>
<style lang="scss">
@import '../../../../../assets/scss/accounting.scss';
</style>
